angular.module('EdxCommonModule', []);